import React, { useEffect, useState } from 'react';
import DsButton from '../../common/DsButton';
import DsModal from '../../common/DsModal';

type Props = {
  open: boolean;
  startAt?: string | null;
  endAt?: string | null;
  saving?: boolean;
  onClose: () => void;
  onSave: (period: { startAt: string; endAt: string }) => void | Promise<void>;
};

export default function EventTicketSalesPeriodModal({
  open,
  startAt,
  endAt,
  saving = false,
  onClose,
  onSave,
}: Props) {
  const [draftStartAt, setDraftStartAt] = useState('');
  const [draftEndAt, setDraftEndAt] = useState('');

  useEffect(() => {
    if (!open) return;
    setDraftStartAt(startAt || '');
    setDraftEndAt(endAt || '');
  }, [endAt, open, startAt]);

  return (
    <DsModal
      open={open}
      onClose={onClose}
      title="イベント共通の券売期間を設定"
      ariaLabel="イベント共通の券売期間を設定"
      size="sm"
      className="event-ticket-setup-submodal"
      overlayClassName="event-ticket-setup-submodal__overlay"
      dismissible={!saving}
      footer={(
        <DsButton
          loading={saving}
          onClick={() => void onSave({ startAt: draftStartAt, endAt: draftEndAt })}
        >
          券売期間を保存
        </DsButton>
      )}
    >
      <p className="event-ticket-setup-submodal__lead">
        各サイトで「券売予定に合わせる」を選ぶ場合に利用します。サイトごとに異なる期間を設定することもできます。
      </p>
      <div className="event-ticket-setup-flow__dates">
        <label>
          開始日時
          <input
            type="datetime-local"
            value={draftStartAt}
            onChange={(event) => setDraftStartAt(event.target.value)}
          />
        </label>
        <label>
          終了日時
          <input
            type="datetime-local"
            min={draftStartAt || undefined}
            value={draftEndAt}
            onChange={(event) => setDraftEndAt(event.target.value)}
          />
        </label>
      </div>
    </DsModal>
  );
}
